import { generator } from "./NumbersUtils"
import { Validations } from "./validations";

declare global {
    interface Array<T> {
        mapWithKey(Method: (item: any) => any): any[];
        mapToIdsList(): any[];
        mapToIdsString(): string;
        filterOnValue(filterKey: string, filterValue: any): any[];
        filterWhenNot(filterKey: string, filterValue: any): any[];
        findFirstValue(filterKey: string, filterValue: any): any;
        findLastValue(filterKey: string, filterValue: any): any;
        findIndexValue(filterKey: string, filterValue: any): number;
        isValueExist(filterKey: string, filterValue: any): boolean;
        isEmpty(): boolean;
    }
}

Array.prototype.mapWithKey = function (Method: (item: any) => any) {
    return this.map((item ,i) => {
        let mappedItem = Validations.isString(item) || Validations.isNumber(item) ? { value: item } : item
      return  Method({ ...mappedItem, key: item?.id || `${Date.now()}-${(Math.random() * 10 ** 20).toString(20).substring(2, 15)}-${i}` })
    })
}

Array.prototype.mapToIdsList = function () {
    return this.map(item => item.value);
}

Array.prototype.mapToIdsString = function () {
    return this.map(item => item.value).join(',');
}

Array.prototype.filterOnValue = function (filterKey: string, filterValue: any) {
    return this.filter(item => item[filterKey] == filterValue);
}

Array.prototype.filterWhenNot = function (filterKey: string, filterValue: any) {
    return this.filter(item => item[filterKey] != filterValue);
}


Array.prototype.findFirstValue = function (filterKey: string, filterValue: any) {
    return this.find(item => item[filterKey] == filterValue);
}

Array.prototype.findLastValue = function (filterKey: string, filterValue: any) {
    return this.findLast(item => item[filterKey] == filterValue);
}

Array.prototype.findIndexValue = function (filterKey: string, filterValue: any) {
    return this.findIndex(item => item[filterKey] == filterValue);
}

Array.prototype.isValueExist = function (filterKey: string, filterValue: any) {
    return this.findIndex(item => item[filterKey] == filterValue) != -1;
}

Array.prototype.isEmpty = function () {
    return this.length === 0;
}
